import { render, staticRenderFns } from "./DiscountConfig.vue?vue&type=template&id=33e6af9a&scoped=true&"
import script from "./DiscountConfig.vue?vue&type=script&lang=js&"
export * from "./DiscountConfig.vue?vue&type=script&lang=js&"
import style0 from "./DiscountConfig.vue?vue&type=style&index=0&id=33e6af9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6af9a",
  null
  
)

export default component.exports